import { pick } from "lodash/fp";

export const serializeError = (error: Error) => pick(['status', 'statusText'], error)